import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n/config";
import { useLanguageDetection } from "./hooks/useLanguageDetection";

// Language Detection Wrapper Component
const AppWithLanguageDetection = () => {
  useLanguageDetection();
  return <App />;
};

createRoot(document.getElementById("root")!).render(<AppWithLanguageDetection />);
